let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lRtGG"), load("9G6yn"), load("l8LL6")]).then(() => parcelRequire('bKXvo'));